export const flights = [
  {
    company: "AirAsia",
    departureCity: "Chennai",
    arrivalCity: "Bangalore",
    departureTime: "7:00",
    duration: "3h 15m",
    arrivalTime: "11:00",
    price: 4500,
    details: [],
    type: "economy",
    f_id: "AirAsia_07:00",
    arrivalCityCode: "BLR",
    departureCityCode: "CHN",
    return_trip: {
      company: "AirAsia",
      f_id: "AirAsia_07:00",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000       
    } 
  },
  {
    company: "IndiGo",
    departureCity: "Chennai",
    arrivalCity: "Bangalore",
    departureTime: "7:00",
    duration: "3h 15m",
    arrivalTime: "11:00",
    price: 2800,
    details: [],
    type: "economy",
    f_id: "IndiGoAirlines_07:00",
    arrivalCityCode: "BLR",
    departureCityCode: "CHN",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Chennai",
      arrivalCity: "Bangalore",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "Air India",
    departureCity: "Chennai",
    arrivalCity: "Delhi",
    departureTime: "7:00",
    duration: "3h 15m",
    arrivalTime: "11:00",
    price: 3000,
    details: [],
    type: "economy",
    f_id: "AirIndia_07:00",
    arrivalCityCode: "DEL",
    departureCityCode: "CHN",
    return_trip: {
      company: "Air India",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "DEL",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "AirAsia",
    departureCity: "Chennai",
    arrivalCity: "Delhi",
    departureTime: "7:00",
    duration: "3h 15m",
    arrivalTime: "11:00",
    price: 3562,
    details: [],
    type: "economy",
    f_id: "AirAsia_07:00",
    arrivalCityCode: "DEL",
    departureCityCode: "CHN",
    return_trip: {
      company: "AirAsia",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "AirAsia",
    departureCity: "Chennai",
    arrivalCity: "Delhi",
    departureTime: "7:00",
    duration: "4h 0m",
    arrivalTime: "11:00",
    price: 8564,
    details: [],
    type: "economy",
    f_id: "AirAsia_07:00",
    arrivalCityCode: "DEL",
    departureCityCode: "CHN",
    return_trip: {
      company: "AirAsia",
      f_id: "IND-203",
      departureCity: "Delhi",
      arrivalCity: "Chennai",
      departureCityCode: "DEL",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "SpiceJet",
    details: [],
    departureTime: "20:55",
    departureCity: "Hyderabad",
    duration: "3h 15m",
    arrivalTime: "00:10",
    arrivalCity: "Chennai",
    price: 8680,
    type: "economy",
    f_id: "SpiceJet_20:55",
    arrivalCityCode: "CHN",
    departureCityCode: "HYD",
    return_trip: {
      company: "SpiceJet",
      f_id: "IND-203",
      departureCity: "Chennai",
      arrivalCity: "Hyderabad",
      departureCityCode: "CHN",
      arrivalCityCode: "HYD",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "19:50",
    departureCity: "Delhi",
    duration: "5h 10m",
    arrivalTime: "01:00",
    arrivalCity: "Bangalore",
    price: 8758,
    type: "economy",
    f_id: "IndiGo_19:50",
    arrivalCityCode: "BLR",
    departureCityCode: "DEL",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Delhi",
      departureCityCode: "BLR",
      arrivalCityCode: "DEL",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "AirAsia India",
    details: [],
    departureTime: "06:55",
    departureCity: "Delhi",
    duration: "5h 30m",
    arrivalTime: "12:25",
    arrivalCity: "Bangalore",
    price: 8985,
    type: "economy",
    f_id: "AirAsia India_06:55",
    arrivalCityCode: "BLR",
    departureCityCode: "DEL",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Delhi",
      departureCityCode: "BLR",
      arrivalCityCode: "DEL",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "AirAsia India",
    details: [],
    departureTime: "20:00",
    departureCity: "Bangalore",
    duration: "10h 55m",
    arrivalTime: "06:55",
    arrivalCity: "Delhi",
    price: 9183,
    type: "economy",
    f_id: "AirAsia India_20:00",
    arrivalCityCode: "DEL",
    departureCityCode: "BLR",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "06:30",
    departureCity: "Bangalore",
    duration: "6h 40m",
    arrivalTime: "13:10",
    arrivalCity: "Delhi",
    price: 9278,
    type: "economy",
    f_id: "IndiGo_06:30",
    arrivalCityCode: "DEL",
    departureCityCode: "BLR",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000       
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "19:50",
    departureCity: "Bangalore",
    duration: "10h 55m",
    arrivalTime: "06:45",
    arrivalCity: "Chennai",
    price: 9370,
    type: "economy",
    f_id: "IndiGo_19:50",
    arrivalCityCode: "CHN",
    departureCityCode: "BLR",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "10:10",
    departureCity: "Chennai",
    duration: "8h 00m",
    arrivalTime: "18:10",
    arrivalCity: "Bangalore",
    price: 9628,
    type: "economy",
    f_id: "IndiGo_10:10",
    arrivalCityCode: "BLR",
    departureCityCode: "CHN",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "01:55",
    departureCity: "Delhi",
    duration: "4h 50m",
    arrivalTime: "06:45",
    arrivalCity: "Chennai",
    price: 9654,
    type: "economy",
    f_id: "IndiGo_01:55",
    arrivalCityCode: "CHN",
    departureCityCode: "DEL",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "06:10",
    departureCity: "Delhi",
    duration: "5h 30m",
    arrivalTime: "11:40",
    arrivalCity: "Bangalore",
    price: 9698,
    type: "economy",
    f_id: "IndiGo_06:10",
    arrivalCityCode: "BLR",
    departureCityCode: "DEL",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "01:55",
    departureCity: "Bangalore",
    duration: "7h 50m",
    arrivalTime: "09:45",
    arrivalCity: "Chennai",
    price: 9734,
    type: "economy",
    f_id: "IndiGo_01:55",
    arrivalCityCode: "CHN",
    departureCityCode: "BLR",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "01:55",
    departureCity: "Chennai",
    duration: "6h 30m",
    arrivalTime: "08:25",
    arrivalCity: "Delhi",
    price: 9787,
    type: "economy",
    f_id: "IndiGo_01:55",
    arrivalCityCode: "DEL",
    departureCityCode: "CHN",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000       
    } 
  },
  {
    company: "AirAsia India",
    details: [],
    departureTime: "22:55",
    departureCity: "Chennai",
    duration: "2h 40m",
    arrivalTime: "01:35",
    arrivalCity: "Bangalore",
    price: 9898,
    type: "economy",
    f_id: "AirAsia India_22:55",
    arrivalCityCode: "BLR",
    departureCityCode: "CHN",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "IndiGo",
    details: [],
    departureTime: "10:10",
    departureCity: "Delhi",
    duration: "8h 55m",
    arrivalTime: "19:05",
    arrivalCity: "Bangalore",
    price: 9923,
    type: "economy",
    f_id: "IndiGo_10:10",
    arrivalCityCode: "BLR",
    departureCityCode: "DEL",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000     
    } 
  },
  {
    company: "AirAsia India",
    details: [],
    departureTime: "05:00",
    departureCity: "Delhi",
    duration: "7h 45m",
    arrivalTime: "12:45",
    arrivalCity: "Bangalore",
    price:8187,
    type: "economy",
    f_id: "AirAsia India_05:00",
    arrivalCityCode: "BLR",
    departureCityCode: "DEL",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
  {
    company: "AirAsia India",
    details: [],
    departureTime: "14:45",
    departureCity: "Bangalore",
    duration: "7h 30m",
    arrivalTime: "22:15",
    arrivalCity: "Delhi",
    price: 9227,
    type: "economy",
    f_id: "AirAsia India_14:45",
    arrivalCityCode: "DEL",
    departureCityCode: "BLR",
    return_trip: {
      company: "Indigo",
      f_id: "IND-203",
      departureCity: "Bangalore",
      arrivalCity: "Chennai",
      departureCityCode: "BLR",
      arrivalCityCode: "CHN",
      retDepartureTime: "09:00",
      retArrivalTime: "11:00",
      price: 7000        
    } 
  },
];
